import React from "react";
import "./About.css";

export default function About() {
  return (
    <div
      className="About"
      id="about"
    >
      <div className="about-me">
        <h1>ABOUT ME</h1>
        <h4>
          Here some information about me, what I do, and my current skills
          mostly in terms of programming and technology
        </h4>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6">
              <h3>
                <strong>This is me!</strong>
              </h3>
              <p>
                I am a highly motivated Materials Engineer that fell in love
                with the web development Frontend world. I made the brave
                decision to transition from Engineering to Web Development, and
                I have absolutely no regrets.
              </p>

              <p>
                Now, I have an overall 3 years of experience in Front-End
                Development, working collaboratively in cross-functional teams
                to improve digital solutions and implement new features to web
                and mobile applications.
              </p>
              <p>
                As a developer, I am constantly tailoring myself to better work,
                studying new techs and looking for new opportunities. I'm a
                quick learner, proactive, frequently I receive compliments
                regarding my communication skills and I can work on my own
                initiative in fast-paced environments. I also believe in
                teamwork and always try to contribute to improvement.
              </p>
              <p>
                I'm open to <strong>job</strong> opportunities where I can
                contribute, learn and grow. If you have a good opportunity that
                matches my skills and experience then don't hesitate to{" "}
                <strong>contact</strong> me.
              </p>
            </div>
            <div className="col-md-6">
              <h3>
                <strong>Skills</strong>
              </h3>
              <ul className="skills">
                <li>HTML</li>
                <li>CSS</li>
                <li>JavaScript</li>
                <li>TypeScript</li>
                <li>React.js</li>
                <li>Redux</li>
                <li>Next.js</li>
                <li>React-Native</li>
                <li>Vue.js</li>
                <li>Docker</li>
                <li>JEST</li>
                <li>Vitest</li>
                <li>Cypress</li>
                <li>Python</li>
                <li>Git</li>
                <li>GitLab</li>
                <li>GitHub</li>
                <li>Responsive Design</li>
                <li>SEO</li>
                <li>Figma Basics</li>
                <li>Kanban</li>
                <li>Scrum</li>
                <li>Agile</li>
                <li>Jira</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
